import { amber, blue, green, grey, orange } from "@mui/material/colors";
/** Refunded order status badge (ST Reports / Sales Order Details). */
export var ST_ORDER_DETAILS_REFUNDED_STATUS_CHIP_COLOR = "#F59E0B";
/** Normalised server / API order status keys for Sales Order Details (Case 59). */
export var ST_ORDER_DETAILS_SERVER_STATUS_KEYS = [
    "completed",
    "paid",
    "pending",
    "refunded",
    "voided",
    "partially_refunded",
];
var ST_ORDER_DETAILS_STATUS_DISPLAY_LABELS = {
    completed: "Completed",
    paid: "Paid",
    pending: "Pending",
    refunded: "Refunded",
    voided: "Voided",
    partially_refunded: "Partially Refunded",
    open: "Draft",
    draft: "Draft",
    unpaid: "Pending",
};
export function normalizeSTOrderDetailsServerStatus(raw) {
    if (raw == null) {
        return "";
    }
    return String(raw)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_");
}
export function getSTOrderDetailsStatusDisplayLabel(raw) {
    var status = normalizeSTOrderDetailsServerStatus(raw);
    if (!status) {
        return "-";
    }
    var mapped = ST_ORDER_DETAILS_STATUS_DISPLAY_LABELS[status];
    if (mapped) {
        return mapped;
    }
    return status
        .split("_")
        .filter(Boolean)
        .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); })
        .join(" ");
}
/** MUI chip background for a server status (matches legacy Sales Order Details colours). */
export function getSTOrderDetailsStatusChipBgColor(raw) {
    var status = normalizeSTOrderDetailsServerStatus(raw);
    switch (status) {
        case "paid":
        case "completed":
            return green[500];
        case "pending":
        case "unpaid":
            return grey[500];
        case "refunded":
            return ST_ORDER_DETAILS_REFUNDED_STATUS_CHIP_COLOR;
        case "partially_refunded":
            return amber[500];
        case "voided":
        case "open":
        case "draft":
            return blue[500];
        default:
            return orange[100];
    }
}
export function classifySTOrderDetailsOrderRow(order) {
    var _a;
    var status = normalizeSTOrderDetailsServerStatus((_a = order === null || order === void 0 ? void 0 : order.OrderStatus) !== null && _a !== void 0 ? _a : order === null || order === void 0 ? void 0 : order.status);
    var isRefundedFinancialStatus = status === "refunded" || status === "partially_refunded" || (order === null || order === void 0 ? void 0 : order.isRefundedOrders) === true;
    var isPaidOrder = !isRefundedFinancialStatus && (status === "paid" || status === "completed");
    var isDraftOrder = !isRefundedFinancialStatus && !isPaidOrder && (status === "open" || status === "voided" || status === "draft");
    var isUnpaid = !isRefundedFinancialStatus && !isPaidOrder && !isDraftOrder && (status === "pending" || status === "unpaid");
    var showsPaidDate = isPaidOrder;
    var showsCommissionAmount = isPaidOrder || status === "refunded" || status === "partially_refunded" || isRefundedFinancialStatus;
    return {
        status: status,
        displayLabel: getSTOrderDetailsStatusDisplayLabel(status),
        chipBgColor: getSTOrderDetailsStatusChipBgColor(status),
        isRefundedFinancialStatus: isRefundedFinancialStatus,
        isPaidOrder: isPaidOrder,
        isDraftOrder: isDraftOrder,
        isUnpaid: isUnpaid,
        showsPaidDate: showsPaidDate,
        showsCommissionAmount: showsCommissionAmount,
    };
}
export function isSTOrderDetailsRefundOrderNoClickable(raw) {
    var status = normalizeSTOrderDetailsServerStatus(raw);
    return status === "refunded" || status === "partially_refunded";
}
